import styled from 'styled-components'

const ErrorMessage = styled.div`
  font-size: 1.2rem;
  color: red;
`

export default ErrorMessage



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/index.js